export default "__VITE_ASSET__b0c095d3__"